// extracted by mini-css-extract-plugin
export default {"row":"Sportsmens_row__eDJU4","card":"Sportsmens_card__MC3y7","col":"Sportsmens_col__j+iWf","card_text":"Sportsmens_card_text__6yHxx","modalTitle":"Sportsmens_modalTitle__H1nzn"};